import * as PIXI from "pixi.js";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


export default class Mainvisual{
    
    constructor() {
        this.app = null;
        this._init();
    }


    render(){
        gsap.to(this.$self, {duration:2, scale:1, ease:'power2.out'});
        gsap.to(this.displacementFilter.scale, {duration:1.4, x:0, y:0, ease:'power2.out'});
        this._parallax();
    }


    _init(){
        gsap.registerPlugin(ScrollTrigger);

        this.$mv = document.querySelector('.mv');
        this.$self = document.querySelector('.js-mv-main');
        this.$logo = document.querySelector('.mv__logo img');

        this._createPixi();
        this._createObj();
        this._setYugami();
    }


    _createPixi(){
        this.textures = window.MyGL._texures;

        this.mw = 1920;
        this.mh = 720;

        this.app = new PIXI.Application({
            width: 1920,
            height: 720,
            backgroundAlpha: 0,
            backgroundColor: 0x000000,
            transparent: true
        });

        this.$self.appendChild(this.app.view);
    }

    _createObj(){
        this.container = new PIXI.Container();

        this.bg = this._createSprite(this.textures.kv_bg);
        this.chara1 = this._createSprite(this.textures.kv_chara1);
        this.chara2 = this._createSprite(this.textures.kv_chara2);
        
        this.container.addChild(this.bg);
        this.container.addChild(this.chara1);
        this.container.addChild(this.chara2);
        this.app.stage.addChild(this.container);
    }

    _createSprite(tex){
        const obj = new PIXI.Sprite(tex);
        obj.anchor.set(0.5);
        obj.x = this.mw/2;
        obj.y = this.mh/2;
        return obj;
    }

    _setYugami(){
        const noise = window.MyGL._texures['noise'];
        this.displacementFilter = new PIXI.filters.DisplacementFilter(new PIXI.Sprite(noise));
        this.displacementFilter.scale.x = 900;
        this.displacementFilter.scale.y = 50;
        this.container.filters = [this.displacementFilter];
    }

    _onResize(){
        const rect = this.$mv.getBoundingClientRect();
        this.mw = rect.width;
        this.mh = rect.height;
        this.bg.x = this.mw/2;
        this.bg.y = this.mh/2;
        this.app.renderer.resize(this.mw, this.mh);
    }


    _parallax(){
        gsap.fromTo(this.bg, 
            {x:this.mw/2},
            {
                x:this.mw/2-50, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        gsap.fromTo(this.bg.scale, 
            {x:1.25, y:1.25},
            {
                x:1, y:1, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );

        gsap.fromTo(this.chara1, 
            {x:this.mw/2-25, y:this.mh/2},
            {
                x:this.mw/2-20, y:this.mh/2+30, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        gsap.fromTo(this.chara1.scale, 
            {x:1.25, y:1.25},
            {
                x:1, y:1, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );

        gsap.fromTo(this.chara2, 
            {x:this.mw/2+25, y:this.mh/2},
            {
                x:this.mw/2-50, y:this.mh/2+10, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        gsap.fromTo(this.chara2.scale, 
            {x:1.25, y:1.25},
            {
                x:0.9, y:0.9, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        

        gsap.fromTo(this.$mv, 
            {y:0},
            {
                y:100, delay:0.1, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0', scrub: 1
                }
            }
        );

        gsap.fromTo(this.$logo, 
            {y:0, opacity:1},
            {
                y:-120, opacity:0, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
    }

    _parallax2(){
        gsap.fromTo(this.bg, 
            {x:this.mw/2},
            {
                x:this.mw/2-50, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        gsap.fromTo(this.bg.scale, 
            {x:1, y:1},
            {
                x:1.05, y:1.05, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );

        gsap.fromTo(this.chara1, 
            {x:this.mw/2},
            {
                x:this.mw/2+30, y:this.mh/2-10, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        gsap.fromTo(this.chara1.scale, 
            {x:1, y:1},
            {
                x:1.2, y:1.2, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );

        gsap.fromTo(this.chara2, 
            {x:this.mw/2},
            {
                x:this.mw/2-60, y:this.mh/2+10, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
        gsap.fromTo(this.chara2.scale, 
            {x:1, y:1},
            {
                x:0.95, y:0.95, duration:0.5, ease:'power2.out', 
                scrollTrigger: {
                    trigger: '.mv',
                    start: 'top 0', end: 'bottom 0%', scrub: 1
                }
            }
        );
    }
}